import { createFeature, createReducer, on } from '@ngrx/store';
import { initialStateResult, PublicAppInfo, ResultState, stateError, stateLoading, stateSuccess } from '@oca/web-shared';
import { GetAppInfo, GetAppInfoFailure, GetAppInfoSuccess } from './app.actions';


export interface AppState {
  appInfo: ResultState<PublicAppInfo>;
}

export const initialState: AppState = {
  appInfo: initialStateResult,
};

export const appReducer = createReducer(
  initialState,
  on(GetAppInfo, (state): AppState => ({ ...state, appInfo: stateLoading(initialState.appInfo.result) })),
  on(GetAppInfoSuccess, (state, action): AppState => ({ ...state, appInfo: stateSuccess(action.data) })),
  on(GetAppInfoFailure, (state, action): AppState => ({ ...state, appInfo: stateError(action.error, state.appInfo.result) })),
);


export const appFeature = createFeature({
  name: 'app',
  reducer: appReducer,
});
